import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import { push } from 'connected-react-router'

// amplify
import { Auth, API } from 'aws-amplify'
import { listStaffProfilesByOrganization } from './../../graphql/queries'
import { createStaffInvitation, sendStaffInvitationEmail, createVolunteerInvitation, sendVolunteerInvitationEmail, createStaffProfile } from './../../graphql/mutations'

import { addStaffProfile } from './organization'

import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { StaffProfile, VolunteerProfile } from '../../../API';

interface TeamState {
    staff: null | StaffProfile[],
    volunteers: null | VolunteerProfile[]
}

const initialState: TeamState = {
    staff: null,
    volunteers: null
}

export const getStaffList: any = createAsyncThunk(
    'team/getStaffList',
    async (props: any, { dispatch, getState }) => {
        try {

            const { authAccount }: any = getState()

            const { data }: any = await API.graphql({
                query: listStaffProfilesByOrganization,
                variables: {
                    organizationID: authAccount.selectedStaffProfile.organization.id
                }
            })

            console.log('retrieved organization staff profiles: ', data)

            const staff = data.listStaffProfilesByOrganization.items
            return staff
        } catch (err) {
            console.error(err)
        }
    }
)

export const getVolunteerList: any = createAsyncThunk(
    'team/getVolunteerList',
    async (props: any, { dispatch, getState }) => {
        try {

            const { authAccount }: any = getState()

            // TODO
            // Connect volunteers to organization via a join table.
            // Pull in all volunteers associated with the organization.

            return []

        } catch (err) {
            console.error(err)
        }
    }
)

interface IInviteStaffMember {
    email: string,
    name: string,
    authAccountId: null | string,
    staffRole: 'admin' | 'staff' | 'superVolunteer'
}

export const inviteStaffMember: any = createAsyncThunk(
    'team/inviteStaffMember',
    async (props: IInviteStaffMember, { dispatch, getState }) => {
        try {

            const { authAccount, organization }: any = getState()

            const createStaffProfileResponse: any = await API.graphql({
                query: createStaffProfile,
                variables: {
                    input: {
                        organizationID: authAccount.selectedStaffProfile.organization.id,
                        role: props.staffRole,
                        name: props.name
                    }
                }
            })

            console.log('create staff profile response: ', createStaffProfileResponse.data)

            const { data }: any = await API.graphql({
                query: createStaffInvitation,
                variables: {
                    input: {
                        code: uuidv4(),
                        type: 'singleUse',
                        email: props.email,
                        organizationID: authAccount.selectedStaffProfile.organization.id,
                        staffProfileID: createStaffProfileResponse.data.createStaffProfile.id,
                        used: false,
                        invitationSent: true,
                        invitationSentTimestamp: new Date()
                    }
                }
            })

            console.log('new invitation data: ', data)

            const invitation = data.createStaffInvitation

            const sendInvitationEmail = await API.graphql({
                query: sendStaffInvitationEmail,
                variables: {
                    input: {
                        organizationName: authAccount.selectedStaffProfile.organization.name,
                        fromEmail: authAccount.cognitoData.email,
                        fromName: authAccount.selectedStaffProfile.organization.name,
                        toEmail: props.email,
                        code: data.createStaffInvitation.code,
                        organizationId: authAccount.selectedStaffProfile.organization.id
                    }
                }
            })

            console.log('new invitation sent: ', sendInvitationEmail)

            toast.success('Invitation sent.', {
                position: "bottom-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                containerId: 'main'
            });

            dispatch(addStaffProfile(createStaffProfileResponse.data.createStaffProfile))

            return {
                invitation,
                staffProfile: createStaffProfileResponse.data.createStaffProfile
            }
        } catch (err) {
            console.error(err)
        }
    }
)

interface IInviteVolunteer {
    email: string,
    name: null | string,
}

export const inviteVolunteer: any = createAsyncThunk(
    'team/inviteVolunteer',
    async (props: IInviteVolunteer, { dispatch, getState }) => {
        try {

            const { authAccount }: any = getState()

            const { data }: any = await API.graphql({
                query: createVolunteerInvitation,
                variables: {
                    input: {
                        code: makeid(6),
                        email: props.email,
                        name: props.name ? props.name : null,
                        organizationID: authAccount.selectedStaffProfile.organization.id,
                        used: false,
                        invitationSent: true,
                        invitationSentTimestamp: new Date()
                    }
                }
            })

            console.log('new invitation data: ', data)

            const invitation = data.createVolunteerInvitation

            const sendInvitationEmail = await API.graphql({
                query: sendVolunteerInvitationEmail,
                variables: {
                    input: {
                        organizationName: authAccount.selectedStaffProfile.organization.name,
                        fromEmail: authAccount.cognitoData.email,
                        fromName: authAccount.selectedStaffProfile.organization.name,
                        toEmail: props.email,
                        code: data.createVolunteerInvitation.code,
                        organizationId: authAccount.selectedStaffProfile.organization.id
                    }
                }
            })

            console.log('new invitation sent: ', sendInvitationEmail)

            toast.success('Invitation sent.', {
                position: "bottom-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                containerId: 'main'
            });

            return invitation
        } catch (err) {
            console.error(err)
        }
    }
)

export const teamSlice = createSlice({
    name: 'team',
    initialState,
    reducers: {
        clearLocalTeamData: (state) => {
            state.staff = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getStaffList.fulfilled, (state, { payload }) => {
            state.staff = payload
        })
        builder.addCase(getVolunteerList.fulfilled, (state, { payload }) => {
            state.volunteers = payload
        })
        builder.addCase(inviteStaffMember.fulfilled, (state, { payload }) => {
            if(state.staff) state.staff.push(payload.staffProfile)
        })
    }
})

export const { clearLocalTeamData } = teamSlice.actions
export default teamSlice.reducer

function makeid(length: number) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}